<link
  rel="stylesheet"
  href="https://use.fontawesome.com/releases/v5.7.0/css/all.css"
  integrity="sha384-lZN37f5QGtY3VHgisS14W3ExzMWZxybE1SJSEsQp9S+oqd12jhcu+A56Ebc1zFSJ"
  crossorigin="anonymous"
/>

<!-- Page content -->
<div class="page-content-wrapper">
  <div class="container position-relative mb-4">
    <h1 class="text-center border-bottom mb-3 pb-3">Create your pizza</h1>
    <div class="row">
      <div class="col-lg-6">
        <img class="img-fluid position-relative primary-image" src="../../../../assets/img/toppings/Crust.png" alt="Pizza Crust">
        <img *ngIf="sauce" class="img-fluid position-absolute secondary-image" src="../../../../assets/img/toppings/Sauce.png" alt="Pizza Sauce">
        <img *ngIf="cheese" class="img-fluid position-absolute secondary-image" src="../../../../assets/img/toppings/Cheese.png" alt="Pizza Cheese">
        <img *ngIf="feta" class="img-fluid position-absolute secondary-image" src="../../../../assets/img/toppings/Feta.png" alt="Feta">
        <img *ngIf="blueCheese" class="img-fluid position-absolute secondary-image" src="../../../../assets/img/toppings/BlueCheese.png" alt="Blue Cheese">
        <img *ngIf="mozzarella" class="img-fluid position-absolute secondary-image" src="../../../../assets/img/toppings/Mozzarella.png" alt="Mozzarella">
        <img *ngIf="pepperoni" class="img-fluid position-absolute secondary-image" src="../../../../assets/img/toppings/Pepperoni.png" alt="Pepperoni">
        <img *ngIf="ham" class="img-fluid position-absolute secondary-image" src="../../../../assets/img/toppings/Ham.png" alt="Ham">
        <img *ngIf="bacon" class="img-fluid position-absolute secondary-image" src="../../../../assets/img/toppings/Bacon.png" alt="Bacon">
        <img *ngIf="chicken" class="img-fluid position-absolute secondary-image" src="../../../../assets/img/toppings/BBQChicken.png" alt="Chicken">
        <img *ngIf="groundBeef" class="img-fluid position-absolute secondary-image" src="../../../../assets/img/toppings/GroundBeef.png" alt="Ground Beef">
        <img *ngIf="pork" class="img-fluid position-absolute secondary-image" src="../../../../assets/img/toppings/Pork.png" alt="Pork">
        <img *ngIf="shrimp" class="img-fluid position-absolute secondary-image" src="../../../../assets/img/toppings/Shrimp.png" alt="Shrimp">
        <img *ngIf="tomato" class="img-fluid position-absolute secondary-image" src="../../../../assets/img/toppings/Tomato.png" alt="Tomato">
        <img *ngIf="pineapple" class="img-fluid position-absolute secondary-image" src="../../../../assets/img/toppings/Pineapple.png" alt="Pineapple">
        <img *ngIf="mushroom" class="img-fluid position-absolute secondary-image" src="../../../../assets/img/toppings/Mushroom.png" alt="Mushroom">
        <img *ngIf="onion" class="img-fluid position-absolute secondary-image" src="../../../../assets/img/toppings/Onion.png" alt="Onion">
        <img *ngIf="pepper" class="img-fluid position-absolute secondary-image" src="../../../../assets/img/toppings/RedPepper.png" alt="Red Pepper">
        <img *ngIf="garlic" class="img-fluid position-absolute secondary-image" src="../../../../assets/img/toppings/Garlic.png" alt="Garlic">
        <img *ngIf="olive" class="img-fluid position-absolute secondary-image" src="../../../../assets/img/toppings/Olive.png" alt="Olive">
        <div>
          <p class="font-weight-bold text-center">Total price: {{ totalPrice.toFixed(2) }}€</p>
        </div>
      </div>
      <!-- <div class="col-md-1"></div> -->
      <div class="col-lg-6">
          <ul>
            <h5 class="border-bottom pb-2" data-toggle="collapse" href="#collapseSize" role="button" aria-expanded="false" aria-controls="collapseSize">
              Size
              <i class="fas fa-angle-down rotate-icon"></i>
            </h5>
            <div class="collapse show" id="collapseSize">
              <div class="col text-center btn-group" data-toggle="buttons" aria-label="Size Buttons">
                <label class="btn pizza-btn">
                  <input type="radio" (click)="onToggleSmall()" name="size" id="small">Small
                </label>
                <label class="btn pizza-btn">
                  <input type="radio" (click)="onToggleMedium()" name="size" id="medium" checked>Medium
                </label>
                <label class="btn pizza-btn">
                  <input type="radio" (click)="onToggleLarge()" name="size" id="large">Large
                </label>
              </div>
            </div>

            <h5 class="border-bottom pb-1 py-2" data-toggle="collapse" href="#collapseSauce" role="button" aria-expanded="false" aria-controls="collapseSauce">
              Sauce
              <i class="fas fa-angle-down rotate-icon"></i>
            </h5>
            <div class="collapse" id="collapseSauce">
              <button type="button" class="btn pizza-btn btn-block active" (click)="onToggleSauce()" id="sauce" data-toggle="button" aria-pressed="true">Sauce</button>
            </div>

            <h5 class="border-bottom pb-1 py-2" data-toggle="collapse" href="#collapseCheese" role="button" aria-expanded="false" aria-controls="collapseCheese">
              Cheese
              <i class="fas fa-angle-down rotate-icon"></i>
            </h5>
            <div class="collapse" id="collapseCheese">
                <button type="button" class="btn pizza-btn btn-block active" (click)="onToggleCheese()" id="cheese" data-toggle="button" aria-pressed="true">Cheese</button>
                <button type="button" class="btn pizza-btn btn-block" (click)="onToggleFeta()" id="feta" data-toggle="button">Feta</button>
                <button type="button" class="btn pizza-btn btn-block" (click)="onToggleBlueCheese()" id="blueCheese" data-toggle="button">Blue Cheese</button>
                <button type="button" class="btn pizza-btn btn-block" (click)="onToggleMozzarella()" id="mozzarella" data-toggle="button">Mozzarella</button>
            </div>

            <h5 class="border-bottom pb-1 py-2" data-toggle="collapse" href="#collapseMeats" role="button" aria-expanded="false" aria-controls="collapseMeats">
              Meats
              <i class="fas fa-angle-down rotate-icon"></i>
            </h5>
            <div class="collapse" id="collapseMeats">
              <button type="button" class="btn pizza-btn btn-block" (click)="onTogglePepperoni()" id="pepperoni" data-toggle="button">Pepperoni</button>
              <button type="button" class="btn pizza-btn btn-block" (click)="onToggleHam()" id="ham" data-toggle="button">Ham</button>
              <button type="button" class="btn pizza-btn btn-block" (click)="onToggleBacon()" id="bacon" data-toggle="button">Bacon</button>
              <button type="button" class="btn pizza-btn btn-block" (click)="onToggleChicken()" id="chicken" data-toggle="button">Chicken</button>
              <button type="button" class="btn pizza-btn btn-block" (click)="onToggleGroundBeef()" id="groundBeef" data-toggle="button">Ground Beef</button>
              <button type="button" class="btn pizza-btn btn-block" (click)="onTogglePork()" id="pork" data-toggle="button">Pork</button>
              <button type="button" class="btn pizza-btn btn-block" (click)="onToggleShrimp()" id="shrimp" data-toggle="button">Shrimp</button>
            </div>

            <h5 class="border-bottom pb-1 py-2" data-toggle="collapse" href="#collapseToppings" role="button" aria-expanded="false" aria-controls="collapseToppings">
              Toppings
              <i class="fas fa-angle-down rotate-icon"></i>
            </h5>
            <div class="collapse" id="collapseToppings">
              <button type="button" class="btn pizza-btn btn-block" (click)="onToggleTomato()" id="tomato" data-toggle="button">Tomato</button>
              <button type="button" class="btn pizza-btn btn-block" (click)="onTogglePineapple()" id="pineapple" data-toggle="button">Pineapple</button>
              <button type="button" class="btn pizza-btn btn-block" (click)="onToggleMushroom()" id="mushroom" data-toggle="button">Mushroom</button>
              <button type="button" class="btn pizza-btn btn-block" (click)="onToggleOnion()" id="onion" data-toggle="button">Onion</button>
              <button type="button" class="btn pizza-btn btn-block" (click)="onToggleRedPepper()" id="pepper" data-toggle="button">Red Pepper</button>
              <button type="button" class="btn pizza-btn btn-block" (click)="onToggleGarlic()" id="garlic" data-toggle="button">Garlic</button>
              <button type="button" class="btn pizza-btn btn-block" (click)="onToggleOlive()" id="olive" data-toggle="button">Olive</button>
            </div>
          </ul>      
        <!-- <app-pizza-toppings *ngFor="let topping of toppings" [topping]="topping">
        </app-pizza-toppings> -->
      </div>
    </div>
  </div>
</div>
<!-- Sidebar -->
<div class="sidebar-wrapper">
  <h3 class="m-3">Order</h3>
  <div class="sidebar-nav text-center m-3">
    <p class="border-bottom-orange"><strong>Size:</strong>  {{ size }}</p>
    <p *ngIf="sauce" class="border-bottom-orange">Sauce</p>
    <p *ngIf="cheese" class="border-bottom-orange">Cheese</p>
    <p *ngIf="feta" class="border-bottom-orange">Feta</p>
    <p *ngIf="blueCheese" class="border-bottom-orange">Blue Cheese</p>
    <p *ngIf="mozzarella" class="border-bottom-orange">Mozzarella</p>
    <div class="container">
      <div class="row">
        <div class="col-sm">
          <p *ngIf="pepperoni" class="border-bottom-orange">Pepperoni</p>
          <p *ngIf="ham" class="border-bottom-orange">Ham</p>
          <p *ngIf="bacon" class="border-bottom-orange">Bacon</p>
          <p *ngIf="chicken" class="border-bottom-orange">Chicken</p>
          <p *ngIf="groundBeef" class="border-bottom-orange">Ground Beef</p>
          <p *ngIf="pork" class="border-bottom-orange">Pork</p>
          <p *ngIf="shrimp" class="border-bottom-orange">Shrimp</p>
        </div>
        <div class="col-sm">
          <p *ngIf="tomato" class="border-bottom-orange">Tomato</p>
          <p *ngIf="pineapple" class="border-bottom-orange">Pineapple</p>
          <p *ngIf="mushroom" class="border-bottom-orange">Mushroom</p>
          <p *ngIf="onion" class="border-bottom-orange">Onion</p>
          <p *ngIf="pepper" class="border-bottom-orange">Red Pepper</p>
          <p *ngIf="garlic" class="border-bottom-orange">Garlic</p>
          <p *ngIf="olive" class="border-bottom-orange">Olive</p>
        </div>
      </div>
    </div>
    <p class="font-weight-bold text-center">Total price: {{ totalPrice.toFixed(2) }}€</p>
  </div>
</div>